import React from 'react';
import { FooterText } from './FooterText';
import { SocialLinks } from './SocialLinks';
import styles from './FooterContent.module.css';

export const FooterContent = () => {
    return (
        <div
            role="presentation"
            className={styles.footerContent}
        >
            <div className={styles.absoluteOverlay}></div>
            <FooterText />
            <SocialLinks />
        </div>
    );
};